import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { Button } from "@babackapp/ui/components/button";
import useTranslation from "@babackapp/translations/use-translation";

interface VerificationInvalidProps {
  onBackToSignIn: () => void;
}

export function VerificationInvalid({ onBackToSignIn }: VerificationInvalidProps) {
  const t = useTranslation();

  return (
    <div className="text-center">
      <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 mb-6">
        <ExclamationTriangleIcon className="h-8 w-8 text-yellow-600" aria-hidden="true" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        {t("verifyEmail.invalid.title")}
      </h3>
      <p className="text-sm text-gray-600 mb-6">
        {t("verifyEmail.invalid.description")}
      </p>
      <Button onClick={onBackToSignIn} className="w-full">
        {t("verifyEmail.invalid.backToSignIn")}
      </Button>
    </div>
  );
}